import { appStore } from '../stores/appStore';
let client = null;
let profile = null;
appStore.subscribe((s) => {
    client = s.client;
    profile = s.profile;
});
function formatRelativeTime(timestamp) {
    if (!timestamp)
        return 'Unknown';
    const date = new Date(Number(timestamp.seconds) * 1000);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);
    if (diffMins < 1)
        return 'just now';
    if (diffMins < 60)
        return `${diffMins} minute${diffMins > 1 ? 's' : ''} ago`;
    if (diffHours < 24)
        return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
    if (diffDays < 30)
        return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
    return date.toLocaleDateString();
}
export async function getStarredRepositories() {
    if (!client) {
        throw new Error('Client not initialized');
    }
    if (!profile?.userName) {
        throw new Error('User not logged in');
    }
    console.log('Fetching starred repositories for:', profile.userName);
    const result = await client.getStarredRepositories({
        username: profile.userName,
    });
    console.log('getStarredRepositories response:', {
        successFull: result.response.successFull,
        repositoryCount: result.response.repositories?.length || 0,
    });
    if (!result.response.successFull) {
        throw new Error(result.response.reason || 'Failed to fetch starred repositories');
    }
    return (result.response.repositories || []).map((repo) => ({
        id: repo.id,
        owner: repo.ownerUsername || 'unknown',
        name: repo.name,
        description: repo.description || '',
        visibility: repo.visibility,
        language: repo.primaryLanguage || 'Unknown',
        languageColor: repo.primaryLanguageColor || '#888888',
        stars: repo.starCount,
        forks: repo.forkCount,
        updatedAt: formatRelativeTime(repo.updatedAt),
    }));
}
